import styled from 'styled-components'

export const BookingSummaryItemUi = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-weight: 500;
  font-size: 14px;
  align-items: center;
`
